import { IBoardConfig } from "../models/essay";

export function useBoardConfig(type: number) {
  const board: IBoardConfig = bancasConfig(type);
  
  return { board }
}

const bancasConfig = (banca: number): IBoardConfig  => {
  switch(banca) {
    case 2: 
      return ENEM;
    case 3:
      return FUVEST;
    case 4:
      return UNESP;
    case 5:
      return UNICAMP;
    case 6:
      return UFPR;
    case 7: 
      return GENEROS;
    default:
      return ENEM;
  }
}

const ENEM = {
  correctionType: 2,
  lines: 30,
  title: false,
  font: {
    18: { maxChars: 2220, lineMaxChars: 74 },
    16: { maxChars: 2490, lineMaxChars: 84 },
    14: { maxChars: 2850, lineMaxChars: 97 }
  },
  paperHeight: 900,
  paper: "https://storage.aprovatotal.com.br/admin-storage-prod/folhas/ENEM.pdf"
};

const FUVEST = {
  correctionType: 3,
  lines: 30,
  title: true,
  font: {
    18: { maxChars: 2220, lineMaxChars: 74 },
    16: { maxChars: 2490, lineMaxChars: 84 },
    14: { maxChars: 2850, lineMaxChars: 97 }
  },
  paperHeight: 900,
  paper: "https://storage.aprovatotal.com.br/admin-storage-prod/folhas/FUVEST.pdf"
};

const UNESP = {
  correctionType: 4,
  lines: 33,
  title: false,
  font: {
    18: { maxChars: 2442, lineMaxChars: 74 },
    16: { maxChars: 2739, lineMaxChars: 84 },
    14: { maxChars: 3135, lineMaxChars: 97 }
  },
  paperHeight: 990,
  paper: "https://storage.aprovatotal.com.br/admin-storage-prod/folhas/VUNESP.pdf"
};

const UNICAMP = {
  correctionType: 5,
  lines: 28,
  title: false,
  font: {
    18: { maxChars: 1776, lineMaxChars: 74 },
    16: { maxChars: 1992, lineMaxChars: 84 },
    14: { maxChars: 2280, lineMaxChars: 97 }
  },
  paperHeight: 850,
  paper: "https://storage.aprovatotal.com.br/admin-storage-prod/folhas/UNICAMP.pdf"
};

const UFPR = {
  correctionType: 6,
  lines: 15,
  title: false,
  font: {
    18: { maxChars: 1110, lineMaxChars: 74 },
    16: { maxChars: 1245, lineMaxChars: 84 },
    14: { maxChars: 1425, lineMaxChars: 97 }
  },
  paperHeight: 450,
  paper: "https://storage.aprovatotal.com.br/admin-storage-prod/folhas/UFPR.pdf"
};

const GENEROS = {
  correctionType: 7,
  lines: 30,
  title: true,
  font: {
    18: { maxChars: 2220, lineMaxChars: 74 },
    16: { maxChars: 2490, lineMaxChars: 84 },
    14: { maxChars: 2850, lineMaxChars: 97 }
  },
  paperHeight: 900,
  paper: "https://storage.aprovatotal.com.br/admin-storage-prod/folhas/GENEROS_TEXTUAIS.pdf"
};